import React, { Component } from 'react';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, showModalPageClass, hideModalPageClass} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';
import ModalMultimedia from '../../../../Partials/ModalMultimedia';

export default class AdmBannerImagenHome extends Component {
    constructor(props) {
        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mbih_Titulo:"",
                mbih_Imagen:"",
                mbih_ImagenMovil:"",
                mbih_Activo:true
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mbih_Id:0,
                mbih_Titulo:"",
                mbih_Imagen:"",
                mbih_ImagenMovil:"",
                mbih_Activo:true
            },
            Validacion: {
                mbih_Titulo: {
                    Error: false,                    
                },
                mbih_Imagen: {
                    Error: false,                    
                },
                mbih_ImagenMovil: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mbih_Titulo: {
                    Error: false,                    
                },
                mbih_Imagen: {
                    Error: false,                    
                },
                mbih_ImagenMovil: {
                    Error: false,                    
                }
            },
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            herramientaAnalisis: this.props.herramientaAnalisis,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:""
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
    }

    getResponseMultimedia = (urlSeleccionada) => {

        let resource = this.state.isEditfieldReturnMultimedia ? this.state.resourceEdit : this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
    
            resource[fieldReturn] = urlSeleccionada;
            
            if(this.state.isEditfieldReturnMultimedia){
                this.setState({resourceEdit:resource, fieldReturnMultimedia:"", isEditfieldReturnMultimedia:false});
            }else{
                this.setState({resource:resource, fieldReturnMultimedia:""});
            }
        }
    
        hideModalPageClass("divGestorArchivosBanImg");
    }
    
    showModalMultimedia = (clase = "", campo = "", isEdition = false) => {
        this.setState({fieldReturnMultimedia:campo, isEditfieldReturnMultimedia:isEdition});
        showModalPageClass(clase);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resourceEdit: copyResource,
            ValidacionEdit: validaciones
        });  
    }

    storeModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mbih_Titulo == '') {              
            newState.Validacion.mbih_Titulo = {Error: true};
            newState.hasError = true;
        }        

        if (newState.resource.mbih_Imagen == '') {  
            newState.Validacion.mbih_Imagen = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mbih_ImagenMovil == '') {  
            newState.Validacion.mbih_ImagenMovil = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloBannerImagenHomeUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mbih_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                    }
        }).then(
        (data)=> {             
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.mbih_Titulo = '';
                stateResponse.resource.mbih_Imagen = '';
                stateResponse.resource.mbih_ImagenMovil = '';
                stateResponse.resource.pmod_Id = result.pmod_Id;
                document.getElementById("pweb_Id").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }).catch((error)=> {
            console.log('Error no controlado.');
            this.setState({loading:false});
        });        
    }

    updateModulo = (e) => {
        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mbih_Titulo == '') {              
            newState.ValidacionEdit.mbih_Titulo = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.mbih_Imagen == '') {  
            newState.Validacion.mbih_Imagen = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.mbih_ImagenMovil == '') {  
            newState.Validacion.mbih_ImagenMovil = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloBannerImagenHomeUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'mbih_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                    }
        }
        ).then(
        (data)=> {             
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }).catch((error)=> {
            console.log('Error no controlado.');
            this.setState({loading:false});
        });        
    }

    closeModulo = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        
        let resourceEdit = this.state.resourceEdit;
        resourceEdit.mbih_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }

    loadModulo = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloBannerImagenHomeUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            this.setState({ resourceEdit: data.result, response: data, error: data.Error });           
        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){
        let mweb = 71;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadModulo(resource.pmod_Id);
            }, 100); 
        }
    } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeModulo()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">
                        {
                            this.state.resourceEdit.mbih_Id > 0 ?
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">
                                    {
                                        this.state.added ?
                                        <div className="txtFile x-1">
                                            <strong style={{
                                                display: "block",
                                                textAlign:"center",
                                                color: "#008000a3"
                                            }}> Registro actualizado satisfactoriamente!!</strong>
                                        </div> : null
                                    }
                                    
                                    <div className="textareaResumen x-1">
                                        <input 
                                            type="text" 
                                            placeholder="Título" 
                                            value={this.state.resourceEdit.mbih_Titulo} 
                                            name="mbih_Titulo"  
                                            className={this.state.ValidacionEdit.mbih_Titulo.Error ? "error" : ""}
                                            onChange={this.handleInputChangeEdit} 
                                            maxLength={255} />
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBanImg", "mbih_Imagen")}/>
                                        <input 
                                            type="text" 
                                            placeholder="Imagen para el Banner" 
                                            value={this.state.resourceEdit.mbih_Imagen} 
                                            name="mbih_Imagen" 
                                            className={this.state.ValidacionEdit.mbih_Imagen.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            maxLength={255} />
										<label class="recomendacion">Se recomienda la dimensión de 1992px de ancho X 600px de alto.</label>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBanImg", "mbih_ImagenMovil")}/>
                                        <input 
                                            type="text" 
                                            placeholder="Imagen para el Banner" 
                                            value={this.state.resourceEdit.mbih_ImagenMovil} 
                                            name="mbih_ImagenMovil" 
                                            className={this.state.ValidacionEdit.mbih_ImagenMovil.Error ? "error" : ""} 
                                            onChange={this.handleInputChange} 
                                            maxLength={255} />
										<label class="recomendacion">Se recomienda la dimensión de 390px de ancho X 480px de alto.</label>
                                    </div>
                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateModulo(e)}>ACTUALIZAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">
                                    <div className="textareaResumen x-1">
                                        <input 
                                            type="text" 
                                            placeholder="Título" 
                                            value={this.state.resource.mbih_Titulo} 
                                            name="mbih_Titulo"  
                                            className={this.state.Validacion.mbih_Titulo.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            maxLength={255} />
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBanImg", "mbih_Imagen")}/>
                                        <input 
                                            type="text" 
                                            placeholder="Imagen para el Banner" 
                                            value={this.state.resource.mbih_Imagen} 
                                            name="mbih_Imagen"  
                                            className={this.state.Validacion.mbih_Imagen.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            maxLength={255} />
										<label class="recomendacion">Se recomienda la dimensión de 1992px de ancho X 600px de alto.</label>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBanImg", "mbih_ImagenMovil")}/>
                                        <input 
                                            type="text" 
                                            placeholder="Imagen para el Banner" 
                                            value={this.state.resource.mbih_ImagenMovil} 
                                            name="mbih_ImagenMovil"  
                                            className={this.state.Validacion.mbih_ImagenMovil.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            maxLength={255} />
										<label class="recomendacion">Se recomienda la dimensión de 390px de ancho X 480px de alto.</label>
                                    </div>
                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeModulo(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                    </div>
                    </div>
                </div>
                <ModalMultimedia class="divGestorArchivosBanImg" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}